import StripeBillingPortalSession from "../interfaces/response/StripeBillingPortalSesssion";
import StripeBillingPortalSessionRequest from "../interfaces/request/StripeBillingPortalSessionRequest";
import { postDataAsync } from "./PortalApi";

export const getStripeBillingPortalSession = (
  sessionRequest: StripeBillingPortalSessionRequest
) => {
  const url = `Stripe/Sessions/Portal`;
  return postDataAsync<
    StripeBillingPortalSessionRequest,
    StripeBillingPortalSession
  >(url, sessionRequest);
};
